import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Select,
  Breadcrumb,
  Input,
  Spin,
  DatePicker,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import moment from "moment";
import { ReactComponent as ClockIcon } from "../../../image/ClockIcon.svg";
import { ReactComponent as RupeesSign } from "../../../image/RupeesSign.svg";
import { ReactComponent as IdcardOutlined } from "../../../image/IdcardOutlined.svg";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import InputField from "../../../common/htmlComponents/InputField";
import ButtonField from "../../../common/htmlComponents/ButtonField";
// import { authUserData } from "../../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";

const AddPurchasedSubscription = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useNavigate();

  const { id } = useParams();
  const purchasedSubscriptionId = id ? atob(id) : null;

  const initialState = {
    company: null,
    subscription: null,
    payment_mode: null,
    per_user_price: null,
    discount: 0,
    sell_price: null,
    duration: null,
    payment_reference_id: null,
    start_date: null,
    end_date: null,
  };
  const [state, setState] = useState(initialState);
  const [companyList, setCompanyList] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState(false);
  const [btnLoading, setBtnloading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);

  useEffect(() => {
    const getCompanyList = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest("company/");
        if (apiResponse.data.results.success) {
          setCompanyList(apiResponse.data.results.data);
        } else {
          ErrorNotificationMsg(t("err_getConcierge"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    const getSubscriptionList = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest("subscription/");
        if (apiResponse.data.results.success) {
          setSubscriptionList(apiResponse.data.results.data);
        } else {
          ErrorNotificationMsg(t("err_getConcierge"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    const getSubscriptionDetail = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          "purchased-subscription/" + purchasedSubscriptionId
        );
        if (apiResponse.data.success) {
          setState({
            ...apiResponse.data.data,
            start_date: apiResponse.data.data.start_date
              ? moment(apiResponse.data.data.start_date, "DD-MM-YYYY").format(
                "DD-MM-YYYY"
              )
              : null,
            end_date: apiResponse.data.data.end_date
              ? moment(apiResponse.data.data.end_date, "DD-MM-YYYY").format(
                "DD-MM-YYYY"
              )
              : null,
          });
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            start_date: apiResponse.data.data.start_date
              ? moment(apiResponse.data.data.start_date, "DD-MM-YYYY")
              : null,
            end_date: apiResponse.data.data.end_date
              ? moment(apiResponse.data.data.end_date, "DD-MM-YYYY")
              : null,
          });
        } else {
          ErrorNotificationMsg(t("err_getConcierge"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    if (purchasedSubscriptionId !== null) {
      getSubscriptionDetail();
    }
    getSubscriptionList();
    getCompanyList();
  }, [purchasedSubscriptionId, t]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
  };

  const handleSelectChange = (field, value) => {
    setState({ ...state, [field]: value });
  };

  const handleDatepickerChange = (date, dateString, fieldName) => {
    setState({ ...state, [fieldName]: dateString ? dateString : null });
  };

  const handleSubscriptionSelectChange = async (value) => {
    const SubscriptionTypeId = value;
    setapiloading(true);
    try {
      const apiResponse = await getRequest(
        "subscription/" + SubscriptionTypeId
      );
      if (apiResponse.data.success) {
        const { per_user_price, discount, sell_price, duration } =
          apiResponse.data.data;
        setState({
          ...state,
          subscription: SubscriptionTypeId,
          per_user_price: per_user_price,
          discount: discount ? discount : 0,
          sell_price: sell_price,
          duration: duration ? Number(duration) : null,
        });
        formRef.current.setFieldsValue({
          per_user_price: apiResponse.data.data.per_user_price,
          discount: apiResponse.data.data.discount,
          sell_price: apiResponse.data.data.sell_price,
          duration: apiResponse.data.data.duration,
        });
      } else {
        ErrorNotificationMsg(t("err_getConcierge"));
      }
      setapiloading(false);
    } catch (error) {
      setapiloading(false);
    }
  };

  const handleDiscountPrice = (field, value) => {
    let actualPrice =
      field === "per_user_price" ? Number(value) : state.per_user_price;
    let discount = field === "discount" ? Number(value) : state.discount;

    let discountValue = (discount / 100) * actualPrice;
    let sellPrice = actualPrice - discountValue;

    setState({
      ...state,
      per_user_price: actualPrice,
      discount: discount,
      sell_price: Math.round(sellPrice),
    });
    formRef.current.setFieldsValue({
      sell_price: sellPrice ? Math.round(sellPrice) : "",
    });
  };

  const handleSubmit = async () => {
    const payload = {
      company: state.company,
      subscription: state.subscription,
      payment_mode: state.payment_mode,
      per_user_price: state.per_user_price,
      discount: state.discount,
      sell_price: state.sell_price,
      duration: state.duration,
      payment_reference_id: state.payment_reference_id,
      start_date: state.start_date
        ? moment(state.start_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : null,
      end_date: state.end_date
        ? moment(state.end_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : null,
    };
    let apiResponse;
    try {
      setBtnloading(true);
      if (purchasedSubscriptionId === null) {
        apiResponse = await postRequest("purchased-subscription/", state);
      } else {
        apiResponse = await patchRequest(
          `purchased-subscription/${purchasedSubscriptionId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        SuccessNotificationMsg(
          purchasedSubscriptionId === null
            ? t("msg_addPurchasedSubscriptionSuccess")
            : t("msg_updatePurchasedSubscriptionSuccess")
        );
        navigate("/purchased-subscription");
        setBtnloading(false);
      }
    } catch (err) {
      setBtnloading(false);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add a new subscription plan with detailed information on features, pricing, and billing cycles.

                </span>
              }
            >
              <h3>
                {" "}
                {purchasedSubscriptionId === null
                  ? t("addPurchasedSubscription")
                  : t("editPurchasedSubscription")}
              </h3>
            </Tooltip>
            <Breadcrumb Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/purchased-subscription">
                  {t("Purchasedsubscription")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {purchasedSubscriptionId === null
                  ? t("addPurchasedSubscription")
                  : t("editPurchasedSubscription")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent">
   <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Row gutter={[15]}>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="company"
                    label={t("pl_company")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_company")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_company")}
                      onChange={(value) => handleSelectChange("company", value)}
                    >
                      {companyList.length &&
                        companyList.map((item, key) => {
                          return (
                            <Select.Option key={key} value={item.id}>
                              {item.name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="subscription"
                    label={t("pl_subscription_type")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_subscription_type")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_subscription")}
                      onChange={(value) =>
                        handleSubscriptionSelectChange(value)
                      }
                    >
                      {subscriptionList.length &&
                        subscriptionList.map((item, key) => {
                          return (
                            <Select.Option key={key} value={item.id}>
                              {item.package_name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    label={t("pl_duration")}
                    name="duration"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_duration")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      prefix={<ClockIcon />}
                      type="number"
                      placeholder={t("pl_enter_duration")}
                      value={state.duration}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    label={t("pl_per_user_price")}
                    name="per_user_price"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_per_user_price")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      prefix={<RupeesSign />}
                      type="number"
                      placeholder={t("pl_enter_per_user_price")}
                      value={state.per_user_price}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item label={t("pl_discount")} name="discount">
                    <Input
                      prefix={<RupeesSign />}
                      type="number"
                      placeholder={t("pl_zero_discount")}
                      onChange={(value) =>
                        handleDiscountPrice("discount", value.target.value)
                      }
                      value={state.discount}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item name="sell_price" label={t("pl_sell_price")}>
                    <Input
                      rules={t("val_sell_price")}
                      prefix={<RupeesSign />}
                      placeholder={t("pl_enter_sell_price")}
                      value={state.sell_price}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="payment_mode"
                    label={t("label_payment_mode")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_payment_mode")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_payment_mode")}
                      onChange={(value) =>
                        handleSelectChange("payment_mode", value)
                      }
                    >
                      <Select.Option value="NEFT">NEFT</Select.Option>
                      <Select.Option value="RTGS">RTGS</Select.Option>
                      <Select.Option value="IMPS">IMPS</Select.Option>
                      <Select.Option value="UPI">UPI</Select.Option>
                      <Select.Option value="Cheque">Cheque</Select.Option>
                      <Select.Option value="Cash">Cash</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    prefix={<IdcardOutlined />}
                    label={t("label_paymentRefId")}
                    placeholder={t("pl_paymentRefId")}
                    name="payment_reference_id"
                    handleInputChange={handleInputChange}
                  />
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="start_date"
                    label={t("pl_label_start_date")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_start_date")}</Trans>,
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      placeholder={t("pl_start_date")}
                      onChange={(date, dateString) =>
                        handleDatepickerChange(date, dateString, "start_date")
                      }
                    // value={state.start_date ? state.start_date : null}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="end_date"
                    label={t("pl_label_end_date")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_end_date")}</Trans>,
                      },
                    ]}
                  >
                    <DatePicker
                      format="DD-MM-YYYY"
                      placeholder={t("pl_end_date")}
                      onChange={(date, dateString) =>
                        handleDatepickerChange(date, dateString, "end_date")
                      }
                    // value={state.end_date ? state.end_date : null}
                    />
                  </Form.Item>
                </Col>
              </Row>

        
            </Form>
          </Spin>
            </div>
                  <div className="FormFooter">
                <ButtonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={() => navigate("/purchased-subscription")}
                />
                {/* {authUserData()?.permission.includes(
                  "subcription|add_purchasedsubscription"
                ) && */}
                <ButtonField
                  type="primary"
                  className="SaveGradiantBtn"
                  label={t("save")}
                  htmlType="submit"
                  loading={btnLoading}
                />
                {/* } */}
              </div>
            </div>
       
        </div>
      </section>
    </>
  );
};

export default AddPurchasedSubscription;
